import React, { forwardRef, useEffect, useState } from "react";
import {
  Group,
  Avatar,
  Text,
  SelectItemProps,
  Autocomplete,
} from "@mantine/core";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { Box } from "@mui/material";
import Airport from "../../models/Airport";
import fetchAirportsQuery from "../../queries/fetchAirportsQuery";
import countries from "../../data/countrie";

interface ItemProps extends SelectItemProps {
  time_zone: string;
  name: string;
  longitude: number;
  latitude: number;
  id: string;
  icao_code: string;
  iata_country_code: string;
  iata_code: string;
  iata_city_code: string;
  city_name: string;

  type: string;

  fr_name: string;
  en_name: string;
  es_name: string;
  it_name: string;
  nl_name: string;
}

const AutoCompleteItem = forwardRef<HTMLDivElement, ItemProps>(
  (
    {
      name,
      city_name,
      iata_code,
      iata_country_code,
      iata_city_code,
      fr_name,
      en_name,
      es_name,
      it_name,
      nl_name,
      ...others
    }: ItemProps,
    ref
  ) => (
    <div ref={ref} {...others} style={{}}>
      <Group
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
        }}>
        <Box
          sx={{
            flex: 0.5,
          }}>
          <LocationOnOutlinedIcon
            sx={{
              fontSize: "18px",
            }}
          />
        </Box>

        <Box
          style={{
            flex: 3,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            fontSize: "13px",
          }}>
          <Text>
            {city_name}-{iata_code}
          </Text>
          <Text color="dimmed">
            {name}-{iata_country_code}
          </Text>
        </Box>
      </Group>
    </div>
  )
);

type Props = {
  placeholder: string;
  options: Airport[];
  label: string;
  value: string;
  onChange: (val: any) => void;
};

const CustomAutoComplete = forwardRef(
  ({ placeholder, options, label, value, onChange }: Props, ref) => {
    const [aiports, setAiports] = useState<Airport[]>([]);
    const [fetchingAirport, setFetchingAirport] = useState<boolean>(false);
    const [query, setQuery] = useState<string>("");

    useEffect(() => {
      fetchAirport(query);
    }, [query]);

    const fetchAirport = (place: string) => {
      onChange(place);
      console.log("====================================");
      console.log("TYPING PLACE: ", place);
      console.log("====================================");
      if (place.length >= 3) {
        setFetchingAirport(true);
        const arrangedAirports: Airport[] = [];
        fetchAirportsQuery(place)
          .then((response: any) => response.json())
          .then((data: any) => {
            console.log("AIRPORT LIST: ", data);
            const tempAirpots: Airport[] = data.data.filter(
              (airp: Airport) => airp.type == "airport"
            );
            tempAirpots.map((airport: Airport) => {
              const getContry = countries.filter(
                (pays) => pays.cca2 == airport.iata_country_code
              )[0];
              airport.fr_name = getContry.translations.fra.official;
              airport.en_name = getContry.name.official;
              airport.es_name = getContry.translations.spa.official;
              airport.it_name = getContry.translations.ita.official;
              airport.nl_name = getContry.translations.nld.official;

              arrangedAirports.push(airport);
            });
            setAiports(arrangedAirports);
            setFetchingAirport(false);
            console.warn("FINAL ARRANGED AIRPORT LIST: ", aiports);
          })
          .catch((err: any) => {
            console.log("Error: ", err);
            setAiports([]);
            setFetchingAirport(false);
          });
      }
    };

    const data = aiports?.map((item: Airport) => ({
      ...item,
      value: `${item.iata_code}-${item.name}-${item.city_name}`,
    }));
    return (
      <Autocomplete
        variant="unstyled"
        aria-label={label}
        placeholder={placeholder}
        itemComponent={AutoCompleteItem}
        maxDropdownHeight={300}
        data={data}
        limit={20}
        filter={(value, item) =>
          item.iata_code.toLowerCase().includes(value.toLowerCase().trim()) ||
          item.name.toLowerCase().includes(value.toLowerCase().trim()) ||
          item.iata_country_code
            .toLowerCase()
            .includes(value.toLowerCase().trim()) ||
          item.fr_name.toLowerCase().includes(value.toLowerCase().trim()) ||
          item.en_name.toLowerCase().includes(value.toLowerCase().trim()) ||
          item.es_name.toLowerCase().includes(value.toLowerCase().trim()) ||
          item.it_name.toLowerCase().includes(value.toLowerCase().trim()) ||
          item.nl_name.toLowerCase().includes(value.toLowerCase().trim()) ||
          item.city_name.toLowerCase().includes(value.toLowerCase().trim())
        }
        value={value}
        // onChange={(val) => setQuery(val)}
        onChange={(val: string) => fetchAirport(val)}
        style={{
          width: "100%",
        }}
      />
    );
  }
);

export default CustomAutoComplete;
